"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const client_1 = __importDefault(require("react-dom/client"));
require("!file-loader?name=styles.css!../css/styles.css");
const App_1 = __importDefault(require("./App"));
const root = client_1.default.createRoot(document.getElementById("react-root"));
root.render(react_1.default.createElement(App_1.default, null));
